// Miky Motorsport - cista matematika vozidla (kvaterniony, brzda, rizeni, anti-roll).
// Bez THREE/Rapier - ciste aritmeticke funkce nad prostymi cisly/objekty, testovatelne
// v Node. physics/vehicle.js je importuje a vola, aby chovani fyziky zustalo identicke.
import { DEG_TO_RAD, INPUT } from './constants.js';
import { clamp } from './physics/tires.js';

// Yaw (otoceni kolem svisle osy Y) jako kvaternion. rad = uhel v radianech.
export function yawQuat(rad) {
  const h = rad * 0.5;
  return { x: 0, y: Math.sin(h), z: 0, w: Math.cos(h) };
}

// Aplikuje brzdny decel na omega kola: brzda jen zpomaluje k nule, nikdy
// neprehoupne znamenko (jinak by brzda roztacela kolo na druhou stranu).
export function brakeOmega(omega, decel) {
  if (omega > 0) return Math.max(0, omega - decel);
  if (omega < 0) return Math.min(0, omega + decel);
  return omega;
}

// Speed-sensitive rejd: max uhel klesa s rychlosti (STEER_MAX_DEG -> STEER_MIN_DEG
// pri STEER_FALLOFF_KMH). Negace (vpravo -> vpravo). Vraci finalni uhel rejdu (rad).
// steerInput = -1..1 (orezano), speedKmh >= 0, maxSteerRad = spec.maxSteerDeg*DEG_TO_RAD.
export function steerAngleFor(steerInput, speedKmh, maxSteerRad) {
  const speedFrac = clamp(speedKmh / INPUT.STEER_FALLOFF_KMH, 0, 1);
  const ratioMin = INPUT.STEER_MIN_DEG / INPUT.STEER_MAX_DEG;
  const maxAngle = maxSteerRad * (1 + (ratioMin - 1) * speedFrac);
  return -clamp(steerInput, -1, 1) * maxAngle;
}

// Anti-roll / self-righting torque: srovnava lokalni up s world-up.
// Osa = up_car x world_up = (-up.z, 0, up.x), velikost ~ sin(naklonu); silnejsi pri
// velkem naklonu (anti-flip), jemny kdyz skoro rovne. Tlumi roll/pitch (slozky angvel
// mimo svislou osu). Vraci { x, z } prispevek do restoring torque (yaw nedotcen).
// up, angvel = {x,y,z}; mass = hmotnost telesa.
export function antiRollTorque(up, angvel, mass) {
  const m = mass;
  const upDot = clamp(up.y, -1, 1);            // cos(naklonu): 1 rovne, -1 vzhuru nohama
  const tilt = 1 - upDot;                       // 0 (rovne) .. 2 (vzhuru nohama)
  const k = m * (3.5 + tilt * 8.0);             // restoring stiffness
  const d = m * 2.4;                            // tlumeni roll/pitch
  return {
    x: -up.z * k - angvel.x * d,
    z: up.x * k - angvel.z * d,
  };
}
